module.exports = __webpack_public_path__ + "img/logo.129a00e6.png";